import React from 'react';
import TopBar from './TopBar';
import './PrivacyPolicyPage.css';
import { useToast } from '../context/ToastContext';

// Privacy Policy Page Component
export default function PrivacyPolicyPage() {
  const email = 'CondoEats050126@gmail.com';
  const { showSuccess, showError } = useToast();

  const handleEmailAction = async () => {
    // Try to copy first for convenience; fail silently but show a toast if it fails
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(email);
        showSuccess('Email address copied to clipboard');
      }
    } catch (err) {
      console.error('Failed to copy:', err);
      showError('Failed to copy email address. Opening mail client instead.');
    } finally {
      // Open user's default mail client (compose window)
      window.location.href = `mailto:${email}`;
    }
  }; 

  return (
    <div className="privacy-policy-page">
      <TopBar />
      <main className="privacy-main">
        <div className="privacy-container">
          <h1 className="privacy-title">Privacy Policy</h1>
          
          <div className="privacy-content">
            <p className="privacy-intro">
              CondoEats values your privacy. This Privacy Policy explains how we collect, use, 
              and protect your information when you use our platform.
            </p>

            <section className="privacy-section">
              <h2 className="privacy-section-title">1. Information We Collect</h2>
              <p className="privacy-text">We may collect:</p>
              <ul className="privacy-list">
                <li>Username, email address, and contact details</li>
                <li>Account and listing information</li>
                <li>Basic usage data for platform improvement</li>
                <li>Limited residential information (i.e. building name/location)</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">2. How We Use Your Information</h2>
              <p className="privacy-text">We use your information to:</p>
              <ul className="privacy-list">
                <li>Operate and improve the CondoEats platform</li>
                <li>Facilitate communication between Buyers and Sellers</li>
                <li>Respond to inquiries or issues</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">3. Data Sharing</h2>
              <ul className="privacy-list">
                <li>CondoEats does not sell, rent, or trade user data to third parties.</li>
                <li>User information is shared only when necessary to facilitate transactions and communication between Buyers and Sellers within the platform.</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">4. Data Security</h2>
              <p className="privacy-text">
                CondoEats takes reasonable measures to protect user information and prevent unauthorised access. 
                User data is handled securely and only accessed when necessary for platform operations.
              </p>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">5. User Responsibility</h2>
              <p className="privacy-text">
                Users are responsible for safeguarding their login credentials.
              </p>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">6. Changes</h2>
              <p className="privacy-text">
                This policy may be updated from time to time.
              </p>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">7. Contact</h2>
              <p className="privacy-text">
                For privacy-related questions, contact:
              </p>
              <div className="privacy-contact">
                <button
                  type="button"
                  className="email-action-btn"
                  onClick={handleEmailAction}
                  aria-label="Email Condo Eats"
                  title="Opens your mail client and copies the email address"
                >
                  {email}
                </button>
              </div> 
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
